import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import Logo from "@/components/Logo";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const location = useLocation();
  const cancelled = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(cancelled ? "cancel" : "checking");

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
      } catch {}
      if (++tries < 10) setTimeout(poll, 2000); else setStatus("failed");
    };
    poll();
  }, [sessionId, cancelled]);

  const view = {
    checking: { icon: <Loader2 className="animate-spin text-[#D4AF37]" size={48} />, title: "Confirming payment…", text: "Please wait a moment." },
    paid: { icon: <CheckCircle2 className="text-green-400" size={48} />, title: "Payment successful", text: "Your subscription is active. Welcome aboard!" },
    cancel: { icon: <XCircle className="text-[#8B9BB4]" size={48} />, title: "Checkout cancelled", text: "No charge was made. You can pick a plan anytime." },
    failed: { icon: <XCircle className="text-red-400" size={48} />, title: "Payment not completed", text: "Something went wrong. Please try again." },
  }[status];

  return (
    <div className="min-h-screen flex items-center justify-center px-4 iw-noise relative">
      <div className="iw-card p-10 max-w-md w-full text-center relative z-10">
        <div className="flex justify-center mb-6"><Logo /></div>
        <div className="flex justify-center mb-4">{view.icon}</div>
        <h1 className="font-display text-2xl font-bold" data-testid="payment-status">{view.title}</h1>
        <p className="text-[#8B9BB4] mt-2">{view.text}</p>
        <Link to="/app" className="btn-gold inline-block px-6 py-3 rounded-full mt-6">Go to Dashboard</Link>
      </div>
    </div>
  );
}
